import { motion } from 'framer-motion';
import { includes } from 'lodash';
import Image from '@/components/shared/Image';
import type { Media as TMediaProps } from '@/graphql/common/types';
import { imageTransitionVariant, imageVariants } from './variants';

type MediaProps = {
  activeIndex: number;
  media?: TMediaProps;
};

export const Media = ({ activeIndex, media }: MediaProps) => {
  const isVideo = includes(media?.mime, 'video') ?? false;

  return (
    <motion.div
      className="relative flex h-full flex-row items-center justify-start"
      key={activeIndex}
      variants={imageVariants}
      initial="initial"
      animate="animate"
      transition={imageTransitionVariant}
    >
      {media && (
        <>
          {isVideo ? (
            <video autoPlay muted loop className="size-full object-cover object-center">
              <source src={media?.url} type={media.mime} />
              Your browser does not support the video tag.
            </video>
          ) : (
            <Image
              src={media.url}
              alt={media.alt ?? ''}
              fill
              quality={100}
              className={'sizes-full object-cover object-center'}
              sizes="(max-width: 600px) 100vw, 600px"
            />
          )}
        </>
      )}
    </motion.div>
  );
};
